<div [formGroup]="formGroup">
    <label [for]="controlName" class="form-control-label">
        {{ label }}
        <span class="text-danger">{{ isRequired ? '*' : '' }}</span>
        <sume-help-tooltip
            *ngIf="helpMessage"
            [message]="helpMessage"
            size="small">
        </sume-help-tooltip>
    </label>
    <select
        [id]="controlName"
        [formControlName]="controlName"
        class="form-control"
        [ngClass]="{
            'is-invalid':
                formControl?.invalid &&
                (formControl?.dirty || formControl?.touched || changeText)
        }"
        (change)="onSelect()">
        <option [ngValue]="null" [disabled]="disable_default">
            {{ messages?.default || 'Selecione um item' }}
        </option>
        <option
            *ngFor="let option of items || []"
            [ngValue]="option[objectValueName]">
            {{ option[objectLabelName] }}
        </option>
    </select>
    <div class="invalid-feedback">
        {{ messages?.invalid || 'Campo inválido' }}
    </div>
</div>
